/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/discounts/discountcode
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDiscountKey,
  ShopifyDiscountRedeemCodeKey,
  ShopifyDiscountRedeemCodeToDiscountKey,
  ShopifyDiscountRedeemCodeToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountRedeemCodeKey,
  "2023-07": {
    name: "Shopify Discount Redeem Code",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "code", graphQLFieldKey: "code" } },
      },
      {
        name: "Async Usage Count",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "async_usage_count", graphQLFieldKey: "asyncUsageCount" } },
      },
      {
        name: "Created By",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_by",
            graphQLFieldKey: "createdBy",
            graphQLSelection: "id apiKey",
          },
        },
      },
      {
        name: "Discount",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountRedeemCodeToDiscountKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "discount_id", graphQLFieldKey: "discountId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyDiscountKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountRedeemCodeToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // in somewhat of a gross an anti-pattern, because shopifyDiscount is already synced through
    // a complicated custom sync, we also sync discountRedeemCodes as part of it
    // although note, that we also need to do this sync on discount webhooks since shopify doesn't
    // send the full discount object in the webhook; so the actual place where the syncing happens is
    // in ShopifyDiscountGraphQLHandler
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDiscountRedeemCode = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
